<div fxShow.gt-sm fxHide.lt-md fxLayout="column" fxFlex="grow" fxFlexFill
     style="padding-left:25px; padding-right: 25px; min-height: calc(100vh - 60px); background: transparent;"
     xmlns="http://www.w3.org/1999/html">
    <div fxLayout="column" style="background: transparent;">


            <div fxLayout="row wrap" fxFlex="grow"
                 fxLayoutAlign.lt-lg="start start center"
                 fxLayoutAlign.gt-md="center start center"
                 fxLayoutGap="15px" style="margin-top:2.5%;">

              <!--#region Left Side-->
              <div fxLayout="column"
                   fxFlex.gt-lg="15"
                   fxFlex.gt-md="20"
                   fxFlex.lt-lg="20"
                   fxLayoutAlign="start">
                <app-left-side [user]="currentUser"
                               (selectedMode)="setSelectedMode($event)"
                               (selectHistory)="scrollToHistory($event)"
                               [notifications]="notifications"></app-left-side>
              </div>
              <!--#endregion-->

              <ng-container *ngIf="displayMode==='consents'">
                <!--Center -->
                <div fxLayout="column"
                     fxFlex.gt-lg="45"
                     fxFlex.gt-md="55"
                     fxFlex.lt-lg="55"
                     fxFlex.lt-md="100"
                     fxLayoutAlign="start">
                  <div>
                    <app-center [selectedChildren]="selectedChildren"
                                [historyScroll]="historyScroll"
                                [loadingNotifications]="loadingNotifications"
                                [loadingCompletedConsents]="loadingCompletedConsents"
                                [loadingChildren]="loadingChildren"
                                [children]="children"
                                [user]="currentUser"
                                [notifications]="notifications"></app-center>
                  </div>

                </div>

                <!--#region Right Side-->
                <div fxLayout="column"
                     fxFlex.gt-lg="15"
                     fxFlex.gt-md="20"
                     fxFlex.lt-lg="20"
                     fxLayoutAlign="start">
                  <app-right-side [user]="currentUser" [loadingChildren]="loadingChildren" [notifications]="notifications"></app-right-side>
                </div>
                <!--#endregion-->
              </ng-container>

              <ng-container *ngIf="displayMode==='history'">

                <div fxLayout="column"
                     fxFlex.gt-lg="60"
                     fxFlex.gt-md="75"
                     fxFlex.lt-lg="75"
                     fxFlex.lt-md="100"
                     fxLayoutAlign="start">

                  <div fxFlex="grow" fxLayout="row" fxLayoutAlign="center center center" style="padding: 15px;
             border-radius: 5px;  background-color: var(--secondaryBlue); color: white; margin-bottom:10px; width: 100%; font-size: 16px;">
                    Ιστορικό δηλώσεων
                  </div>

                  <mat-card>
                    <mat-card-content>
                      <app-completed-consents [user]="currentUser"></app-completed-consents>
                    </mat-card-content>
                  </mat-card>
                </div>


              </ng-container>


              <ng-container *ngIf="displayMode==='messages'">
                <div fxLayout="column"
                     fxFlex.gt-lg="60"
                     fxFlex.gt-md="75"
                     fxFlex.lt-lg="75"
                     fxFlex.lt-md="100"
                     fxLayoutAlign="start">

                  <div fxFlex="grow" fxLayout="row" fxLayoutAlign="center center center" style="padding: 15px;
             border-radius: 5px;  background-color: var(--secondaryBlue); color: white; margin-bottom:10px; width: 100%; font-size: 16px;">
                    Τα μηνύματά μου
                  </div>

                  <mat-card>
                    <mat-card-content>
                      <app-my-messages-dialog></app-my-messages-dialog>
                    </mat-card-content>
                  </mat-card>
                </div>
              </ng-container>
            </div>
    </div>
</div>


<div fxLayout="column" fxShow.lt-md fxHide.gt-sm style="background: transparent; min-height: calc(100vh - 60px);" fxFlex="grow" fxLayoutGap="15px">
    <app-available-consents *ngIf="!loadingNotifications" [consents]="notifications"
                            [currentUser]="currentUser"></app-available-consents>
    <div *ngIf="loadingNotifications" fxLayout="column" style="width: 94vw;" fxLayoutGap="10px">
        <app-skeleton-loading></app-skeleton-loading>
        <app-skeleton-loading></app-skeleton-loading>
        <app-skeleton-loading></app-skeleton-loading>
    </div>
</div>
